import React from "react";

function Logo() {
  return (
    <div>
      <ul className="flex flex-1 flex-wrap list-none px-4 p-4">
        <li className="text-4xl cursor-pointer">Tasky</li>
      </ul>
    </div>
  );
}

export default Logo;
